import ChannelChart from 'components/channel/ChannelChart';
import React from 'react';


class ChannelChartStack extends React.Component {
  computeXAxisRange(channels) {
    if (this.props.xAxisMin && this.props.xAxisMax) {
      return [this.props.xAxisMin, this.props.xAxisMax];
    }

    const minTspanMillis = 15 * 1000;

    const hasData = c => c.getData() && c.getData().length;
    const getMin = c => c.getData()[0].t.getTime();
    const getMax = c => c.getData()[c.getData().length - 1].t.getTime();
    const mins = Object.values(channels).map(i => i.channel).filter(hasData).map(getMin);
    const maxs = Object.values(channels).map(i => i.channel).filter(hasData).map(getMax);
    let min;
    let max;
    if (mins.length && maxs.length) {
      min = Math.min(...mins);
      max = Math.max(...maxs);
    } else {
      min = new Date().getTime();
      max = min + minTspanMillis;
    }
    let tspan = minTspanMillis;
    while (max - min > tspan) {
      tspan *= 2;
    }
    return [min, min + tspan];
  }

  footer(_) {
    return '';
  }

  render() {
    const channels = this.props.channels;
    const xAxisRange = this.computeXAxisRange(channels);
    let chartContent =
        Object.keys(channels).sort().map((id, n) =>
            <ChannelChart
                key={id} channelId={id}
                xAxisMin={xAxisRange[0]} xAxisMax={xAxisRange[1]}
                aspectRatio={this.props.aspectRatio}
                isLast={n + 1 === Object.keys(channels).length}
                channel={this.props.channels[id].channel} />)
    let footer = this.footer(xAxisRange);
    return <div>{chartContent}{footer}</div>;
  }
}


export default ChannelChartStack;
